module.exports = __webpack_public_path__ + "img/index-vision-3.a11b1525.png";